export function getGuaUa () {
  return navigator ? navigator.userAgent : null;
}
